class MainProduct extends HTMLElement {
    constructor() {
        super()

        this._selectors = {
            "addToCart": ".prd-Details_Buttons button[type='submit'].prd-Details_Button-addToCart",
            "productVariants": "[js-product-variants]"
        }

        this._elements = {
            "addToCart": this.querySelector(this._selectors.addToCart),
        }

        this.productId = this.getAttribute('data-product-id')
        this.productVariants = JSON.parse(this.querySelector(this._selectors.productVariants).textContent) || []
        this.ticketId = null

    }

    connectedCallback() {
        window.elevate.onTrackingConsentGranted(() => {
            this.getElevateTicketId()

            window.BAO.eventBus.addEventListener(
                window.BAO.EVENTS.PUSH_CART.AFTER_ADD,
                this.handleAfterAddToCart.bind(this)
            )
        })
    }

    async handleAfterAddToCart(event) {
        if (!this.ticketId || !this?.contains(event?.detail?.form)) return

        await window.elevate.api.notify.addToCart(this.ticketId);
    }

    async getElevateTicketId() {
        try {
            const productKey = (window.location.pathname.split('/').pop() ?? '').slice(0, 50)
            const response = await window.elevate.api.query.productPage({
                customerKey: window.elevate.customerKey,
                locale: window.elevate.locale,
                market: window.elevate.market,
                productKey,
                touchpoint: window.elevate.touchpoint,
                sessionKey: window.elevate.sessionKey,
            })

            const ticketId = Object.values(response?.tickets ?? {})[0];
            this.ticketId = ticketId ?? null
        } catch (error) {
            // gracefully fail
        }
    }
}

if (!customElements.get('main-product')) {
    customElements.define('main-product', MainProduct)
}
